import React from 'react';
import PropTypes from 'prop-types';
import { pick, noop } from 'lodash';
import { LayoutListener } from '@dbk/ui-responsive';
import { View } from '@dbk/ui-react-utils';
import { propTypes, contextTypes, privateOrientationType } from '../common';
import Arrow from './arrow';
import CloseBtn from './close-btn';
import * as styles from './styles';
import {titleContainer , titleText} from './popover-content-container.styles';
import Text, {Small ,Large } from '../../common/text';
import {  CloseIcon } from '@dbk/ui-icons';


export default class PopoverContentContainer extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
      .isRequired,
    onMouseLeave: PropTypes.func,
    onHide: PropTypes.func.isRequired,
    closing: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    orientation: privateOrientationType,
   // title: PropTypes.string.isRequired,
    ...pick(propTypes, [
      'popOverClassName',
      'position',
      'showCloseButton',
      'mode',
      'id',
      'testID',
    ]),
  };
  static defaultProps = {
    onMouseLeave: noop,
    orientation: '',
    title:'',
    onClick: noop,
    closePopover: false
  };
  static contextTypes = contextTypes;

  constructor() {
    super();
    this.state = {
      contentHeight: undefined,
    };
  }
  componentDidUpdate(nextProps){
    if(this.props.closePopover !== nextProps.closePopover){
      this.props.onHide()
    }
  }
  setContentHeight = ({ height }) => {
    this.setState({
      contentHeight: height + 1,
    });
  };

  getContent = () => {
    /* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/no-static-element-interactions */
    const {
      mode,
      orientation,
      children,
      showCloseButton,
      popOverClassName,
      onHide,
      type,
      title,
      toolTipAlert,
    } = this.props;
    const classes = styles.getContentWrapperClassNames(
      orientation,
      popOverClassName,
      showCloseButton,
      this.context.inverse,
      type
    );
    return (
      <LayoutListener
        style={styles.getWidth(mode, orientation)}
        className={classes}
        onLayout={this.setContentHeight}
      >

        {
          toolTipAlert ? (<div style={titleContainer}> 
          <Text style={titleText}>{title}</Text> 
          <div onClick={onHide}>
          <CloseIcon height={16} width={16} color={'#000E28'} />
          </div> 
        </div>):
        showCloseButton && <CloseBtn onClick={onHide} />
        }
        {children}
      </LayoutListener>
    );
  };

  render() {
    const {
      orientation,
      position,
      type,
      onMouseLeave,
      closing,
      id,
      mode,
      testID,
      arrowColor,
      title,
      onClick
    } = this.props;
    const content = this.getContent();
    const classes = styles.getContainerWrapperClassNames(
      closing,
      mode,
      orientation
    );
    return (
      <View
        className={classes}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        aria-hidden={closing}
        aria-describedby={id}
        data-test-id={testID}
      >
        <Arrow
          orientation={orientation}
          position={position}
          bottomEdge={this.state.contentHeight}
          type={type}
          arrowColor={arrowColor}
        />
        {content}
      </View>
    );
  }
}
